// bskr/button-dropdown
//
// Toggles the panel open/closed when the trigger button is clicked.
// CSS drives the max-height + opacity animation; JS only manages the
// is-open class and aria-expanded attribute.

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".button-dropdown").forEach((block) => {
        const trigger = block.querySelector(".button-dropdown__trigger");
        if (!trigger) return;

        // If rendered open by default, set the panel max-height to its real height.
        if (block.classList.contains("is-open")) {
            const panel = block.querySelector(".button-dropdown__panel");
            if (panel) panel.style.maxHeight = panel.scrollHeight + "px";
        }

        trigger.addEventListener("click", () => {
            const isOpen = trigger.getAttribute("aria-expanded") === "true";
            const panel  = block.querySelector(".button-dropdown__panel");

            if (isOpen) {
                // Closing: fix current height first so transition has a start value
                panel.style.maxHeight = panel.scrollHeight + "px";
                requestAnimationFrame(() => {
                    panel.style.maxHeight = "0";
                });
            } else {
                // Opening: animate to exact content height
                panel.style.maxHeight = panel.scrollHeight + "px";
            }

            trigger.setAttribute("aria-expanded", String(!isOpen));
            block.classList.toggle("is-open", !isOpen);
        });
    });
});
